"use strict";

export default function ($stateProvider) {
  "ngInject";
  $stateProvider.state("files", {
    url: "/files",
    template: "<files></files>",
  });
}



// WEBPACK FOOTER //
// ./client/app/files/files.routes.js